
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
//require('./plugins/select2');

import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
//window.vSelect  = require('vue-select')
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//Vue.component('v-select', vSelect.VueSelect);


Vue.mixin({
    data: function () {
        return {
            states: [

                { "label": "Alabama", "value": "AL" },
                { "label": "Alaska", "value": "AK" },
                { "label": "Arizona", "value": "AZ" },
                { "label": "Arkansas", "value": "AR" },
                { "label": "California", "value": "CA" },
                { "label": "Colorado", "value": "CO" },
                { "label": "Connecticut", "value": "CT" },
                { "label": "Delaware", "value": "DE" },
                { "label": "District Of Columbia", "value": "DC" },
                { "label": "Florida", "value": "FL" },
                { "label": "Georgia", "value": "GA" },
                { "label": "Hawaii", "value": "HI" },
                { "label": "Idaho", "value": "value" },
                { "label": "Illinois", "value": "IL" },
                { "label": "Indiana", "value": "IN" },
                { "label": "Iowa", "value": "IA" },
                { "label": "Kansas", "value": "KS" },
                { "label": "Kentucky", "value": "KY" },
                { "label": "Louisiana", "value": "LA" },
                { "label": "Maine", "value": "ME" },
                { "label": "Maryland", "value": "MD" },
                { "label": "Massachusetts", "value": "MA" },
                { "label": "Michigan", "value": "MI" },
                { "label": "Minnesota", "value": "MN" },
                { "label": "Mississippi", "value": "MS" },
                { "label": "Missouri", "value": "MO" },
                { "label": "Montana", "value": "MT" },
                { "label": "Nebraska", "value": "NE" },
                { "label": "Nevada", "value": "NV" },
                { "label": "New Hampshire", "value": "NH" },
                { "label": "New Jersey", "value": "NJ" },
                { "label": "New Mexico", "value": "NM" },
                { "label": "New York", "value": "NY" },
                { "label": "North Carolina", "value": "NC" },
                { "label": "North Dakota", "value": "ND" },
                { "label": "Ohio", "value": "OH" },
                { "label": "Oklahoma", "value": "OK" },
                { "label": "Oregon", "value": "OR" },
                { "label": "Pennsylvania", "value": "PA" },
                { "label": "Puerto Rico", "value": "PR" },
                { "label": "Rhode Island", "value": "RI" },
                { "label": "South Carolina", "value": "SC" },
                { "label": "South Dakota", "value": "SD" },
                { "label": "Tennessee", "value": "TN" },
                { "label": "Texas", "value": "TX" },
                { "label": "Utah", "value": "UT" },
                { "label": "Vermont", "value": "VT" },
                { "label": "Virginia", "value": "VA" },
                { "label": "Washington", "value": "WA" },
                { "label": "West Virginia", "value": "WV" },
                { "label": "Wisconsin", "value": "WI" },
                { "label": "Wyoming", "value": "WY" }
            ]
        }
    },
    methods: {

    }
})


Vue.component('ranking', require('./components/Ranking.vue').default);
Vue.component('results', require('./components/Results.vue').default);

const Chart = Vue.component('chart', require('./components/Chart.vue').default);
const Rankings = Vue.component('rakings', require('./components/Rankings.vue').default);

const routes = [
    {path: '/:pb?/rankings', component: Rankings, name: 'rankings'},
    { path: '/:pb?/chart/:id', component: Chart, name: 'chart' }
]

const router = new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
})

Vue.mixin({
    data: function () {
        return {
            computed: {
                get apiGateway() {
                    return document.location.origin
                }
            }
        }
    }
})

const app = new Vue({
    router
}).$mount('#bestforvets')
